// encryptData.js
import CryptoJS from "crypto-js";

const SECRET_KEY = '8F90K7uz2L9Z1Q6P2X';

export function encryptData(data) {
    const ciphertext = CryptoJS.AES.encrypt(JSON.stringify(data), SECRET_KEY).toString();
    return ciphertext;
}

export function decryptData(ciphertext) {
    try {
        const bytes = CryptoJS.AES.decrypt(ciphertext, SECRET_KEY);
        const decrypted = bytes.toString(CryptoJS.enc.Utf8);
        if (!decrypted) {
            throw new Error("Decryption failed. Result is empty or malformed.");
        }

        return JSON.parse(decrypted);
    } catch (err) {
        console.error(" Decryption error:", err.message);
        throw err;
    }
}